$ {
    const propertyOrdering = input.propertyOrdering;
    const imageSize = input.imageSize;
    const __signal = input.__signal;
    const isSmall = input.isSmall;
    const testId = input.testId;
}

<div class="str-item-card__header-container" data-testid=testId>
    <str-ordered-properties
        properties=propertyOrdering
        card={ ...input, __signal }
        sectionName="header"
        imageSize=imageSize
        isSmall=isSmall
    />
</div>
